module.exports = __webpack_public_path__ + "static/img/loca-competition.b5ebe41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/loca-competition.jpg
// module id = 7QqM
// module chunks = 0